"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_ADS_TAB_ROUTE = exports.Networks = exports.ROI_TYPE = void 0;
var ROI_TYPE = {
  LEAD_COST_ROI: 'LEAD_COST_ROI',
  DEALS_ROI: 'DEALS_ROI'
};
exports.ROI_TYPE = ROI_TYPE;
var Networks = {
  FACEBOOK: 'FACEBOOK',
  ADWORDS: 'ADWORDS',
  LINKEDIN: 'LINKEDIN'
};
exports.Networks = Networks;
var BASE_ADS_TAB_ROUTE = 'marketing/ads';
exports.BASE_ADS_TAB_ROUTE = BASE_ADS_TAB_ROUTE;